import React, {
  ReactNode,
} from 'react';

type Props = {
  title: string;
  description: string;
  icon: ReactNode;
  onClick: () => void;
};

export default function SupportPortalOptionCard({
  title,
  description,
  icon,
  onClick,
}: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full rounded-xl border border-slate-200 bg-white p-6 text-left shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500/60"
    >
      <div className="flex flex-col gap-4">
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-slate-900 text-white">
          {icon}
        </span>
        <div className="flex flex-col gap-2">
          <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
          <p className="text-sm leading-6 text-slate-600">{description}</p>
        </div>
      </div>
    </button>
  );
}
